import './css/index.css';
import 'components/breadcrumbs';
import 'components/article-intro';
import 'components/article-intro-wide';
import 'components/article-body';
import 'components/card-event';
import 'components/group-cards-article';
import 'components/footer';
import 'components/notification';
import 'components/blockquote';
import 'components/info-overlay';

// import last
import 'components/snippets/callouts';
import 'components/snippets/images';
import 'components/snippets/footnotes';

import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation,
        {
            name: 'info-overlay',
            module: () => import(
                'components/info-overlay'
            )
        }
    ],

    init() {

        console.info( 'The Article Page has initiated.' );

    },

    ready() {

        console.info( 'The Article Page is ready.' );

        console.info( 'Components:', this.components );

    }

} );
